var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{on:{"click":_vm.speak}},[_vm._v("speak")])
}
var staticRenderFns = []

export { render, staticRenderFns }